import { debounce, getMediaDevice } from "../../helpers";

export default () => {
  const func = ({ condition }: { condition?: boolean }) => {
    const header = document.querySelector("header");
    const comp: HTMLElement | null = document.querySelector(
      ".homepage-highlights"
    );

    if (header !== null && comp !== null && condition) {
      const containerHeight = window.innerHeight - header.offsetHeight - 15;
      comp.style.height = `${containerHeight}px`;
    }
  };

  func({
    condition: getMediaDevice() != "MOBILE" && getMediaDevice() != "TABLET"
  });
  debounce({
    func,
    delay: 125,
    condition: getMediaDevice() != "MOBILE" && getMediaDevice() != "TABLET"
  });
};
